{
	"ordersInfo": {
		"ticker": "Тикер",
		"option": "Опцион",
		"tickerCompany": "Тикер/Комп",
		"operation": "Операция",
		"quantity": "Количество",
		"sum": "Сумма",
		"profitability": "Доходность",
		"dateTime": "Дата/Время",
		"actions": "Действия",
		"price": "Цена",
		"openedOrders": "Открытые ордера",
		"statusTitle": "Статус",
		"term": "Срок",
		"orderStatus": "Статус ордера",
		"orderStatusPlaceholder": "Выберите статус ордера",
		"orderType": "Тип ордера",
		"executed": "Исполнено",
		"averagePrice": "Средняя цена",
		"averageExecutedPrice": "Средняя исп. цена",
		"orderDuration": "Срок ордера",
		"profitabilityInPercent": "Доходность в %",
		"brokerCommission": "Комиссия брокера",
		"placed": "Дата размещения",
		"updated": "Дата обновления",
		"filled": "Дата исполнения",
		"canceled": "Дата отмены",
		"close": "Закрыть",
		"stopPrice": "Стоп цена",
		"limitPrice": "Лимит цена",
		"trailPrice": "Трейл-цена",
		"trailPercent": "Трейл-процент",
		"stopLoss": "Stop Loss",
		"takeProfit": "Take Profit",
		"pcs": "шт.",
		"orderId": "ID",
		"side": {
			"buy": "Купить",
			"sell": "Продать",
			"sell_short": "Продажа в шорт"
		},
		"terms": {
			"day": "DAY",
			"gtc": "GTC",
			"opg": "OPG",
			"cls": "CLS",
			"ioc": "IOC",
			"dayPlus": "DAY+"
		}
	}
}
